"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Add = _interopRequireDefault(require("./iconTypes/16Add.js"));

var _Add2 = _interopRequireDefault(require("./iconTypes/24Add.js"));

var _AddCircleFill = _interopRequireDefault(require("./iconTypes/16AddCircleFill.js"));

var _AddCircleFill2 = _interopRequireDefault(require("./iconTypes/24AddCircleFill.js"));

var _AddCircleLine = _interopRequireDefault(require("./iconTypes/16AddCircleLine.js"));

var _AddCircleLine2 = _interopRequireDefault(require("./iconTypes/24AddCircleLine.js"));

var _AddSquareFill = _interopRequireDefault(require("./iconTypes/16AddSquareFill.js"));

var _AddSquareFill2 = _interopRequireDefault(require("./iconTypes/24AddSquareFill.js"));

var _AddSquareLine = _interopRequireDefault(require("./iconTypes/16AddSquareLine.js"));

var _AddSquareLine2 = _interopRequireDefault(require("./iconTypes/24AddSquareLine.js"));

var _AlcoholLine = _interopRequireDefault(require("./iconTypes/24AlcoholLine.js"));

var _ArrowDown = _interopRequireDefault(require("./iconTypes/16ArrowDown.js"));

var _ArrowDown2 = _interopRequireDefault(require("./iconTypes/24ArrowDown.js"));

var _ArrowDownLeft = _interopRequireDefault(require("./iconTypes/16ArrowDownLeft.js"));

var _ArrowDownLeft2 = _interopRequireDefault(require("./iconTypes/24ArrowDownLeft.js"));

var _ArrowDownRight = _interopRequireDefault(require("./iconTypes/16ArrowDownRight.js"));

var _ArrowDownRight2 = _interopRequireDefault(require("./iconTypes/24ArrowDownRight.js"));

var _ArrowLeft = _interopRequireDefault(require("./iconTypes/16ArrowLeft.js"));

var _ArrowLeft2 = _interopRequireDefault(require("./iconTypes/24ArrowLeft.js"));

var _ArrowRight = _interopRequireDefault(require("./iconTypes/16ArrowRight.js"));

var _ArrowRight2 = _interopRequireDefault(require("./iconTypes/24ArrowRight.js"));

var _ArrowUp = _interopRequireDefault(require("./iconTypes/16ArrowUp.js"));

var _ArrowUp2 = _interopRequireDefault(require("./iconTypes/24ArrowUp.js"));

var _ArrowUpLeft = _interopRequireDefault(require("./iconTypes/16ArrowUpLeft.js"));

var _ArrowUpLeft2 = _interopRequireDefault(require("./iconTypes/24ArrowUpLeft.js"));

var _ArrowUpRight = _interopRequireDefault(require("./iconTypes/16ArrowUpRight.js"));

var _ArrowUpRight2 = _interopRequireDefault(require("./iconTypes/24ArrowUpRight.js"));

var _BlobAlmondblob = _interopRequireDefault(require("./iconTypes/16BlobAlmondblob.js"));

var _BlobAlmondblob2 = _interopRequireDefault(require("./iconTypes/24BlobAlmondblob.js"));

var _BlobAvoblob = _interopRequireDefault(require("./iconTypes/16BlobAvoblob.js"));

var _BlobAvoblob2 = _interopRequireDefault(require("./iconTypes/24BlobAvoblob.js"));

var _BlobMusselblob = _interopRequireDefault(require("./iconTypes/16BlobMusselblob.js"));

var _BlobMusselblob2 = _interopRequireDefault(require("./iconTypes/24BlobMusselblob.js"));

var _BlobPearblob = _interopRequireDefault(require("./iconTypes/16BlobPearblob.js"));

var _BlobPearblob2 = _interopRequireDefault(require("./iconTypes/24BlobPearblob.js"));

var _BlobRibsblob = _interopRequireDefault(require("./iconTypes/16BlobRibsblob.js"));

var _BlobRibsblob2 = _interopRequireDefault(require("./iconTypes/24BlobRibsblob.js"));

var _BlobSteakblob = _interopRequireDefault(require("./iconTypes/16BlobSteakblob.js"));

var _BlobSteakblob2 = _interopRequireDefault(require("./iconTypes/24BlobSteakblob.js"));

var _BoltFill = _interopRequireDefault(require("./iconTypes/16BoltFill.js"));

var _BoltFill2 = _interopRequireDefault(require("./iconTypes/24BoltFill.js"));

var _BoltLine = _interopRequireDefault(require("./iconTypes/16BoltLine.js"));

var _BoltLine2 = _interopRequireDefault(require("./iconTypes/24BoltLine.js"));

var _BrowseFill = _interopRequireDefault(require("./iconTypes/16BrowseFill.js"));

var _BrowseFill2 = _interopRequireDefault(require("./iconTypes/24BrowseFill.js"));

var _BrowseLine = _interopRequireDefault(require("./iconTypes/16BrowseLine.js"));

var _BrowseLine2 = _interopRequireDefault(require("./iconTypes/24BrowseLine.js"));

var _CalendarAddFill = _interopRequireDefault(require("./iconTypes/16CalendarAddFill.js"));

var _CalendarAddFill2 = _interopRequireDefault(require("./iconTypes/24CalendarAddFill.js"));

var _CalendarAddLine = _interopRequireDefault(require("./iconTypes/16CalendarAddLine.js"));

var _CalendarAddLine2 = _interopRequireDefault(require("./iconTypes/24CalendarAddLine.js"));

var _CalendarCancelFill = _interopRequireDefault(require("./iconTypes/16CalendarCancelFill.js"));

var _CalendarCancelFill2 = _interopRequireDefault(require("./iconTypes/24CalendarCancelFill.js"));

var _CalendarCancelLine = _interopRequireDefault(require("./iconTypes/16CalendarCancelLine.js"));

var _CalendarCancelLine2 = _interopRequireDefault(require("./iconTypes/24CalendarCancelLine.js"));

var _CalendarCheckFill = _interopRequireDefault(require("./iconTypes/16CalendarCheckFill.js"));

var _CalendarCheckFill2 = _interopRequireDefault(require("./iconTypes/24CalendarCheckFill.js"));

var _CalendarCheckLine = _interopRequireDefault(require("./iconTypes/16CalendarCheckLine.js"));

var _CalendarCheckLine2 = _interopRequireDefault(require("./iconTypes/24CalendarCheckLine.js"));

var _CalendarFill = _interopRequireDefault(require("./iconTypes/16CalendarFill.js"));

var _CalendarFill2 = _interopRequireDefault(require("./iconTypes/24CalendarFill.js"));

var _CalendarLine = _interopRequireDefault(require("./iconTypes/16CalendarLine.js"));

var _CalendarLine2 = _interopRequireDefault(require("./iconTypes/24CalendarLine.js"));

var _CallCustomer = _interopRequireDefault(require("./iconTypes/24CallCustomer.js"));

var _CallDasher = _interopRequireDefault(require("./iconTypes/24CallDasher.js"));

var _CallMerchant = _interopRequireDefault(require("./iconTypes/24CallMerchant.js"));

var _CallOffice = _interopRequireDefault(require("./iconTypes/24CallOffice.js"));

var _CameraFill = _interopRequireDefault(require("./iconTypes/16CameraFill.js"));

var _CameraFill2 = _interopRequireDefault(require("./iconTypes/24CameraFill.js"));

var _CameraLine = _interopRequireDefault(require("./iconTypes/16CameraLine.js"));

var _CameraLine2 = _interopRequireDefault(require("./iconTypes/24CameraLine.js"));

var _CardFill = _interopRequireDefault(require("./iconTypes/16CardFill.js"));

var _CardFill2 = _interopRequireDefault(require("./iconTypes/24CardFill.js"));

var _CardLine = _interopRequireDefault(require("./iconTypes/16CardLine.js"));

var _CardLine2 = _interopRequireDefault(require("./iconTypes/24CardLine.js"));

var _CartFill = _interopRequireDefault(require("./iconTypes/16CartFill.js"));

var _CartFill2 = _interopRequireDefault(require("./iconTypes/24CartFill.js"));

var _CartLine = _interopRequireDefault(require("./iconTypes/16CartLine.js"));

var _CartLine2 = _interopRequireDefault(require("./iconTypes/24CartLine.js"));

var _Challenge = _interopRequireDefault(require("./iconTypes/16Challenge.js"));

var _Challenge2 = _interopRequireDefault(require("./iconTypes/24Challenge.js"));

var _ChatConversation = _interopRequireDefault(require("./iconTypes/24ChatConversation.js"));

var _ChatCustomer = _interopRequireDefault(require("./iconTypes/24ChatCustomer.js"));

var _ChatDasher = _interopRequireDefault(require("./iconTypes/24ChatDasher.js"));

var _ChatDefaultFill = _interopRequireDefault(require("./iconTypes/16ChatDefaultFill.js"));

var _ChatDefaultFill2 = _interopRequireDefault(require("./iconTypes/24ChatDefaultFill.js"));

var _ChatDefaultLine = _interopRequireDefault(require("./iconTypes/16ChatDefaultLine.js"));

var _ChatDefaultLine2 = _interopRequireDefault(require("./iconTypes/24ChatDefaultLine.js"));

var _ChatMerchant = _interopRequireDefault(require("./iconTypes/24ChatMerchant.js"));

var _ChatOffice = _interopRequireDefault(require("./iconTypes/24ChatOffice.js"));

var _Check = _interopRequireDefault(require("./iconTypes/16Check.js"));

var _Check2 = _interopRequireDefault(require("./iconTypes/24Check.js"));

var _CheckCircleFill = _interopRequireDefault(require("./iconTypes/16CheckCircleFill.js"));

var _CheckCircleFill2 = _interopRequireDefault(require("./iconTypes/24CheckCircleFill.js"));

var _CheckCircleLine = _interopRequireDefault(require("./iconTypes/16CheckCircleLine.js"));

var _CheckCircleLine2 = _interopRequireDefault(require("./iconTypes/24CheckCircleLine.js"));

var _CheckSquareFill = _interopRequireDefault(require("./iconTypes/16CheckSquareFill.js"));

var _CheckSquareFill2 = _interopRequireDefault(require("./iconTypes/24CheckSquareFill.js"));

var _CheckSquareLine = _interopRequireDefault(require("./iconTypes/16CheckSquareLine.js"));

var _CheckSquareLine2 = _interopRequireDefault(require("./iconTypes/24CheckSquareLine.js"));

var _CheckSquareOffLine = _interopRequireDefault(require("./iconTypes/16CheckSquareOffLine.js"));

var _CheckSquareOffLine2 = _interopRequireDefault(require("./iconTypes/24CheckSquareOffLine.js"));

var _ChevronDown = _interopRequireDefault(require("./iconTypes/16ChevronDown.js"));

var _ChevronDown2 = _interopRequireDefault(require("./iconTypes/24ChevronDown.js"));

var _ChevronLeft = _interopRequireDefault(require("./iconTypes/16ChevronLeft.js"));

var _ChevronLeft2 = _interopRequireDefault(require("./iconTypes/24ChevronLeft.js"));

var _ChevronRight = _interopRequireDefault(require("./iconTypes/16ChevronRight.js"));

var _ChevronRight2 = _interopRequireDefault(require("./iconTypes/24ChevronRight.js"));

var _ChevronUp = _interopRequireDefault(require("./iconTypes/16ChevronUp.js"));

var _ChevronUp2 = _interopRequireDefault(require("./iconTypes/24ChevronUp.js"));

var _Close = _interopRequireDefault(require("./iconTypes/16Close.js"));

var _Close2 = _interopRequireDefault(require("./iconTypes/24Close.js"));

var _CloseCircleFill = _interopRequireDefault(require("./iconTypes/16CloseCircleFill.js"));

var _CloseCircleFill2 = _interopRequireDefault(require("./iconTypes/24CloseCircleFill.js"));

var _CloseCircleLine = _interopRequireDefault(require("./iconTypes/16CloseCircleLine.js"));

var _CloseCircleLine2 = _interopRequireDefault(require("./iconTypes/24CloseCircleLine.js"));

var _CloseSquareFill = _interopRequireDefault(require("./iconTypes/16CloseSquareFill.js"));

var _CloseSquareFill2 = _interopRequireDefault(require("./iconTypes/24CloseSquareFill.js"));

var _CloseSquareLine = _interopRequireDefault(require("./iconTypes/16CloseSquareLine.js"));

var _CloseSquareLine2 = _interopRequireDefault(require("./iconTypes/24CloseSquareLine.js"));

var _CopyFill = _interopRequireDefault(require("./iconTypes/16CopyFill.js"));

var _CopyFill2 = _interopRequireDefault(require("./iconTypes/24CopyFill.js"));

var _CopyLine = _interopRequireDefault(require("./iconTypes/16CopyLine.js"));

var _CopyLine2 = _interopRequireDefault(require("./iconTypes/24CopyLine.js"));

var _DashboardFill = _interopRequireDefault(require("./iconTypes/16DashboardFill.js"));

var _DashboardFill2 = _interopRequireDefault(require("./iconTypes/24DashboardFill.js"));

var _DashboardLine = _interopRequireDefault(require("./iconTypes/16DashboardLine.js"));

var _DashboardLine2 = _interopRequireDefault(require("./iconTypes/24DashboardLine.js"));

var _DealsFill = _interopRequireDefault(require("./iconTypes/16DealsFill.js"));

var _DealsFill2 = _interopRequireDefault(require("./iconTypes/24DealsFill.js"));

var _DealsLine = _interopRequireDefault(require("./iconTypes/16DealsLine.js"));

var _DealsLine2 = _interopRequireDefault(require("./iconTypes/24DealsLine.js"));

var _DevicePhone = _interopRequireDefault(require("./iconTypes/16DevicePhone.js"));

var _DevicePhone2 = _interopRequireDefault(require("./iconTypes/24DevicePhone.js"));

var _DevicePosFill = _interopRequireDefault(require("./iconTypes/16DevicePosFill.js"));

var _DevicePosFill2 = _interopRequireDefault(require("./iconTypes/24DevicePosFill.js"));

var _DevicePosLine = _interopRequireDefault(require("./iconTypes/16DevicePosLine.js"));

var _DevicePosLine2 = _interopRequireDefault(require("./iconTypes/24DevicePosLine.js"));

var _DeviceTablet = _interopRequireDefault(require("./iconTypes/16DeviceTablet.js"));

var _DeviceTablet2 = _interopRequireDefault(require("./iconTypes/24DeviceTablet.js"));

var _DirectionsFill = _interopRequireDefault(require("./iconTypes/16DirectionsFill.js"));

var _DirectionsFill2 = _interopRequireDefault(require("./iconTypes/24DirectionsFill.js"));

var _DirectionsLine = _interopRequireDefault(require("./iconTypes/16DirectionsLine.js"));

var _DirectionsLine2 = _interopRequireDefault(require("./iconTypes/24DirectionsLine.js"));

var _DownloadFill = _interopRequireDefault(require("./iconTypes/16DownloadFill.js"));

var _DownloadLine = _interopRequireDefault(require("./iconTypes/24DownloadLine.js"));

var _EditFill = _interopRequireDefault(require("./iconTypes/16EditFill.js"));

var _EditFill2 = _interopRequireDefault(require("./iconTypes/24EditFill.js"));

var _EditLine = _interopRequireDefault(require("./iconTypes/16EditLine.js"));

var _EditLine2 = _interopRequireDefault(require("./iconTypes/24EditLine.js"));

var _EmailFill = _interopRequireDefault(require("./iconTypes/16EmailFill.js"));

var _EmailFill2 = _interopRequireDefault(require("./iconTypes/24EmailFill.js"));

var _EmailLine = _interopRequireDefault(require("./iconTypes/16EmailLine.js"));

var _EmailLine2 = _interopRequireDefault(require("./iconTypes/24EmailLine.js"));

var _EyeHiddenFill = _interopRequireDefault(require("./iconTypes/16EyeHiddenFill.js"));

var _EyeHiddenFill2 = _interopRequireDefault(require("./iconTypes/24EyeHiddenFill.js"));

var _EyeHiddenLine = _interopRequireDefault(require("./iconTypes/16EyeHiddenLine.js"));

var _EyeHiddenLine2 = _interopRequireDefault(require("./iconTypes/24EyeHiddenLine.js"));

var _EyeVisibleFill = _interopRequireDefault(require("./iconTypes/16EyeVisibleFill.js"));

var _EyeVisibleFill2 = _interopRequireDefault(require("./iconTypes/24EyeVisibleFill.js"));

var _EyeVisibleLine = _interopRequireDefault(require("./iconTypes/16EyeVisibleLine.js"));

var _EyeVisibleLine2 = _interopRequireDefault(require("./iconTypes/24EyeVisibleLine.js"));

var _FavoriteFill = _interopRequireDefault(require("./iconTypes/16FavoriteFill.js"));

var _FavoriteFill2 = _interopRequireDefault(require("./iconTypes/24FavoriteFill.js"));

var _FavoriteLine = _interopRequireDefault(require("./iconTypes/16FavoriteLine.js"));

var _FavoriteLine2 = _interopRequireDefault(require("./iconTypes/24FavoriteLine.js"));

var _FaxFill = _interopRequireDefault(require("./iconTypes/16FaxFill.js"));

var _FaxFill2 = _interopRequireDefault(require("./iconTypes/24FaxFill.js"));

var _FaxLine = _interopRequireDefault(require("./iconTypes/16FaxLine.js"));

var _FaxLine2 = _interopRequireDefault(require("./iconTypes/24FaxLine.js"));

var _FilterFill = _interopRequireDefault(require("./iconTypes/16FilterFill.js"));

var _FilterFill2 = _interopRequireDefault(require("./iconTypes/24FilterFill.js"));

var _FilterLine = _interopRequireDefault(require("./iconTypes/16FilterLine.js"));

var _FilterLine2 = _interopRequireDefault(require("./iconTypes/24FilterLine.js"));

var _FoodLine = _interopRequireDefault(require("./iconTypes/16FoodLine.js"));

var _FoodLine2 = _interopRequireDefault(require("./iconTypes/24FoodLine.js"));

var _FunnelLine = _interopRequireDefault(require("./iconTypes/16FunnelLine.js"));

var _FunnelLine2 = _interopRequireDefault(require("./iconTypes/24FunnelLine.js"));

var _GlobeFill = _interopRequireDefault(require("./iconTypes/16GlobeFill.js"));

var _GlobeFill2 = _interopRequireDefault(require("./iconTypes/24GlobeFill.js"));

var _GlobeLine = _interopRequireDefault(require("./iconTypes/16GlobeLine.js"));

var _GlobeLine2 = _interopRequireDefault(require("./iconTypes/24GlobeLine.js"));

var _HalfFill = _interopRequireDefault(require("./iconTypes/16HalfFill.js"));

var _HalfFill2 = _interopRequireDefault(require("./iconTypes/24HalfFill.js"));

var _HalfLine = _interopRequireDefault(require("./iconTypes/16HalfLine.js"));

var _HalfLine2 = _interopRequireDefault(require("./iconTypes/24HalfLine.js"));

var _HelpCircleFill = _interopRequireDefault(require("./iconTypes/16HelpCircleFill.js"));

var _HelpCircleFill2 = _interopRequireDefault(require("./iconTypes/24HelpCircleFill.js"));

var _HelpCircleLine = _interopRequireDefault(require("./iconTypes/16HelpCircleLine.js"));

var _HelpCircleLine2 = _interopRequireDefault(require("./iconTypes/24HelpCircleLine.js"));

var _HelpLifesaver = _interopRequireDefault(require("./iconTypes/16HelpLifesaver.js"));

var _HelpLifesaver2 = _interopRequireDefault(require("./iconTypes/24HelpLifesaver.js"));

var _HomeFill = _interopRequireDefault(require("./iconTypes/16HomeFill.js"));

var _HomeFill2 = _interopRequireDefault(require("./iconTypes/24HomeFill.js"));

var _HomeLine = _interopRequireDefault(require("./iconTypes/16HomeLine.js"));

var _HomeLine2 = _interopRequireDefault(require("./iconTypes/24HomeLine.js"));

var _InfoCircleFill = _interopRequireDefault(require("./iconTypes/16InfoCircleFill.js"));

var _InfoCircleFill2 = _interopRequireDefault(require("./iconTypes/24InfoCircleFill.js"));

var _InfoCircleLine = _interopRequireDefault(require("./iconTypes/16InfoCircleLine.js"));

var _InfoCircleLine2 = _interopRequireDefault(require("./iconTypes/24InfoCircleLine.js"));

var _List = _interopRequireDefault(require("./iconTypes/16List.js"));

var _List2 = _interopRequireDefault(require("./iconTypes/24List.js"));

var _LocationGpsFill = _interopRequireDefault(require("./iconTypes/16LocationGpsFill.js"));

var _LocationGpsFill2 = _interopRequireDefault(require("./iconTypes/24LocationGpsFill.js"));

var _LocationGpsLine = _interopRequireDefault(require("./iconTypes/16LocationGpsLine.js"));

var _LocationGpsLine2 = _interopRequireDefault(require("./iconTypes/24LocationGpsLine.js"));

var _LocationPinDisabledFill = _interopRequireDefault(require("./iconTypes/16LocationPinDisabledFill.js"));

var _LocationPinDisabledFill2 = _interopRequireDefault(require("./iconTypes/24LocationPinDisabledFill.js"));

var _LocationPinDisabledLine = _interopRequireDefault(require("./iconTypes/16LocationPinDisabledLine.js"));

var _LocationPinDisabledLine2 = _interopRequireDefault(require("./iconTypes/24LocationPinDisabledLine.js"));

var _LocationPinEnabledFill = _interopRequireDefault(require("./iconTypes/16LocationPinEnabledFill.js"));

var _LocationPinEnabledFill2 = _interopRequireDefault(require("./iconTypes/24LocationPinEnabledFill.js"));

var _LocationPinEnabledLine = _interopRequireDefault(require("./iconTypes/16LocationPinEnabledLine.js"));

var _LocationPinEnabledLine2 = _interopRequireDefault(require("./iconTypes/24LocationPinEnabledLine.js"));

var _LocationPointerFill = _interopRequireDefault(require("./iconTypes/16LocationPointerFill.js"));

var _LocationPointerFill2 = _interopRequireDefault(require("./iconTypes/24LocationPointerFill.js"));

var _LocationPointerLine = _interopRequireDefault(require("./iconTypes/16LocationPointerLine.js"));

var _LocationPointerLine2 = _interopRequireDefault(require("./iconTypes/24LocationPointerLine.js"));

var _LockedFill = _interopRequireDefault(require("./iconTypes/16LockedFill.js"));

var _LockedFill2 = _interopRequireDefault(require("./iconTypes/24LockedFill.js"));

var _LockedLine = _interopRequireDefault(require("./iconTypes/16LockedLine.js"));

var _LockedLine2 = _interopRequireDefault(require("./iconTypes/24LockedLine.js"));

var _LogoAndroid = _interopRequireDefault(require("./iconTypes/16LogoAndroid.js"));

var _LogoAndroid2 = _interopRequireDefault(require("./iconTypes/24LogoAndroid.js"));

var _LogoApple = _interopRequireDefault(require("./iconTypes/16LogoApple.js"));

var _LogoApple2 = _interopRequireDefault(require("./iconTypes/24LogoApple.js"));

var _LogoDashpass = _interopRequireDefault(require("./iconTypes/16LogoDashpass.js"));

var _LogoDashpass2 = _interopRequireDefault(require("./iconTypes/24LogoDashpass.js"));

var _LogoDashpassMonocolor = _interopRequireDefault(require("./iconTypes/16LogoDashpassMonocolor.js"));

var _LogoDashpassMonocolor2 = _interopRequireDefault(require("./iconTypes/24LogoDashpassMonocolor.js"));

var _LogoDoordash = _interopRequireDefault(require("./iconTypes/16LogoDoordash.js"));

var _LogoDoordash2 = _interopRequireDefault(require("./iconTypes/24LogoDoordash.js"));

var _LogoFacebook = _interopRequireDefault(require("./iconTypes/16LogoFacebook.js"));

var _LogoFacebook2 = _interopRequireDefault(require("./iconTypes/24LogoFacebook.js"));

var _LogoGlassdoor = _interopRequireDefault(require("./iconTypes/16LogoGlassdoor.js"));

var _LogoGlassdoor2 = _interopRequireDefault(require("./iconTypes/24LogoGlassdoor.js"));

var _LogoGoogle = _interopRequireDefault(require("./iconTypes/16LogoGoogle.js"));

var _LogoGoogle2 = _interopRequireDefault(require("./iconTypes/24LogoGoogle.js"));

var _LogoInstagram = _interopRequireDefault(require("./iconTypes/16LogoInstagram.js"));

var _LogoInstagram2 = _interopRequireDefault(require("./iconTypes/24LogoInstagram.js"));

var _LogoLinkedin = _interopRequireDefault(require("./iconTypes/16LogoLinkedin.js"));

var _LogoLinkedin2 = _interopRequireDefault(require("./iconTypes/24LogoLinkedin.js"));

var _LogoMedium = _interopRequireDefault(require("./iconTypes/16LogoMedium.js"));

var _LogoMedium2 = _interopRequireDefault(require("./iconTypes/24LogoMedium.js"));

var _LogoTwitter = _interopRequireDefault(require("./iconTypes/16LogoTwitter.js"));

var _LogoTwitter2 = _interopRequireDefault(require("./iconTypes/24LogoTwitter.js"));

var _LogoutFill = _interopRequireDefault(require("./iconTypes/16LogoutFill.js"));

var _LogoutLine = _interopRequireDefault(require("./iconTypes/24LogoutLine.js"));

var _MapFill = _interopRequireDefault(require("./iconTypes/16MapFill.js"));

var _MapFill2 = _interopRequireDefault(require("./iconTypes/24MapFill.js"));

var _MapLine = _interopRequireDefault(require("./iconTypes/16MapLine.js"));

var _MapLine2 = _interopRequireDefault(require("./iconTypes/24MapLine.js"));

var _Menu = _interopRequireDefault(require("./iconTypes/16Menu.js"));

var _Menu2 = _interopRequireDefault(require("./iconTypes/24Menu.js"));

var _MenuEditFill = _interopRequireDefault(require("./iconTypes/16MenuEditFill.js"));

var _MenuEditFill2 = _interopRequireDefault(require("./iconTypes/24MenuEditFill.js"));

var _MenuEditLine = _interopRequireDefault(require("./iconTypes/16MenuEditLine.js"));

var _MenuEditLine2 = _interopRequireDefault(require("./iconTypes/24MenuEditLine.js"));

var _MenuShare = _interopRequireDefault(require("./iconTypes/16MenuShare.js"));

var _MenuShare2 = _interopRequireDefault(require("./iconTypes/24MenuShare.js"));

var _MerchantFill = _interopRequireDefault(require("./iconTypes/16MerchantFill.js"));

var _MerchantFill2 = _interopRequireDefault(require("./iconTypes/24MerchantFill.js"));

var _MerchantLine = _interopRequireDefault(require("./iconTypes/16MerchantLine.js"));

var _MerchantLine2 = _interopRequireDefault(require("./iconTypes/24MerchantLine.js"));

var _MoneyBank = _interopRequireDefault(require("./iconTypes/16MoneyBank.js"));

var _MoneyBank2 = _interopRequireDefault(require("./iconTypes/24MoneyBank.js"));

var _MoneyCircleFill = _interopRequireDefault(require("./iconTypes/16MoneyCircleFill.js"));

var _MoneyCircleFill2 = _interopRequireDefault(require("./iconTypes/24MoneyCircleFill.js"));

var _MoneyCircleLine = _interopRequireDefault(require("./iconTypes/16MoneyCircleLine.js"));

var _MoneyCircleLine2 = _interopRequireDefault(require("./iconTypes/24MoneyCircleLine.js"));

var _MoneyDefault = _interopRequireDefault(require("./iconTypes/16MoneyDefault.js"));

var _MoneyDefault2 = _interopRequireDefault(require("./iconTypes/24MoneyDefault.js"));

var _MoreHorizontal = _interopRequireDefault(require("./iconTypes/16MoreHorizontal.js"));

var _MoreHorizontal2 = _interopRequireDefault(require("./iconTypes/24MoreHorizontal.js"));

var _MoreVertical = _interopRequireDefault(require("./iconTypes/24MoreVertical.js"));

var _NotifyFill = _interopRequireDefault(require("./iconTypes/16NotifyFill.js"));

var _NotifyFill2 = _interopRequireDefault(require("./iconTypes/24NotifyFill.js"));

var _NotifyLine = _interopRequireDefault(require("./iconTypes/16NotifyLine.js"));

var _NotifyLine2 = _interopRequireDefault(require("./iconTypes/24NotifyLine.js"));

var _Office = _interopRequireDefault(require("./iconTypes/16Office.js"));

var _Office2 = _interopRequireDefault(require("./iconTypes/24Office.js"));

var _OrderBagFill = _interopRequireDefault(require("./iconTypes/16OrderBagFill.js"));

var _OrderBagFill2 = _interopRequireDefault(require("./iconTypes/24OrderBagFill.js"));

var _OrderBagLine = _interopRequireDefault(require("./iconTypes/16OrderBagLine.js"));

var _OrderBagLine2 = _interopRequireDefault(require("./iconTypes/24OrderBagLine.js"));

var _OrderHotbagFill = _interopRequireDefault(require("./iconTypes/16OrderHotbagFill.js"));

var _OrderHotbagFill2 = _interopRequireDefault(require("./iconTypes/24OrderHotbagFill.js"));

var _OrderHotbagLine = _interopRequireDefault(require("./iconTypes/16OrderHotbagLine.js"));

var _OrderHotbagLine2 = _interopRequireDefault(require("./iconTypes/24OrderHotbagLine.js"));

var _OrderLargeFill = _interopRequireDefault(require("./iconTypes/16OrderLargeFill.js"));

var _OrderLargeFill2 = _interopRequireDefault(require("./iconTypes/24OrderLargeFill.js"));

var _OrderLargeLine = _interopRequireDefault(require("./iconTypes/16OrderLargeLine.js"));

var _OrderLargeLine2 = _interopRequireDefault(require("./iconTypes/24OrderLargeLine.js"));

var _OrderMediumFill = _interopRequireDefault(require("./iconTypes/16OrderMediumFill.js"));

var _OrderMediumFill2 = _interopRequireDefault(require("./iconTypes/24OrderMediumFill.js"));

var _OrderMediumLine = _interopRequireDefault(require("./iconTypes/16OrderMediumLine.js"));

var _OrderMediumLine2 = _interopRequireDefault(require("./iconTypes/24OrderMediumLine.js"));

var _OrderProtocol = _interopRequireDefault(require("./iconTypes/16OrderProtocol.js"));

var _OrderProtocol2 = _interopRequireDefault(require("./iconTypes/24OrderProtocol.js"));

var _OrderSmallFill = _interopRequireDefault(require("./iconTypes/16OrderSmallFill.js"));

var _OrderSmallFill2 = _interopRequireDefault(require("./iconTypes/24OrderSmallFill.js"));

var _OrderSmallLine = _interopRequireDefault(require("./iconTypes/16OrderSmallLine.js"));

var _OrderSmallLine2 = _interopRequireDefault(require("./iconTypes/24OrderSmallLine.js"));

var _PeopleAddFill = _interopRequireDefault(require("./iconTypes/16PeopleAddFill.js"));

var _PeopleAddFill2 = _interopRequireDefault(require("./iconTypes/24PeopleAddFill.js"));

var _PeopleAddLine = _interopRequireDefault(require("./iconTypes/16PeopleAddLine.js"));

var _PeopleAddLine2 = _interopRequireDefault(require("./iconTypes/24PeopleAddLine.js"));

var _PeopleGroupFill = _interopRequireDefault(require("./iconTypes/16PeopleGroupFill.js"));

var _PeopleGroupFill2 = _interopRequireDefault(require("./iconTypes/24PeopleGroupFill.js"));

var _PeopleGroupLine = _interopRequireDefault(require("./iconTypes/16PeopleGroupLine.js"));

var _PeopleGroupLine2 = _interopRequireDefault(require("./iconTypes/24PeopleGroupLine.js"));

var _PersonProfileFill = _interopRequireDefault(require("./iconTypes/16PersonProfileFill.js"));

var _PersonProfileFill2 = _interopRequireDefault(require("./iconTypes/24PersonProfileFill.js"));

var _PersonProfileLine = _interopRequireDefault(require("./iconTypes/16PersonProfileLine.js"));

var _PersonProfileLine2 = _interopRequireDefault(require("./iconTypes/24PersonProfileLine.js"));

var _PersonUserFill = _interopRequireDefault(require("./iconTypes/16PersonUserFill.js"));

var _PersonUserFill2 = _interopRequireDefault(require("./iconTypes/24PersonUserFill.js"));

var _PersonUserLine = _interopRequireDefault(require("./iconTypes/16PersonUserLine.js"));

var _PersonUserLine2 = _interopRequireDefault(require("./iconTypes/24PersonUserLine.js"));

var _PhoneCallFill = _interopRequireDefault(require("./iconTypes/16PhoneCallFill.js"));

var _PhoneCallFill2 = _interopRequireDefault(require("./iconTypes/24PhoneCallFill.js"));

var _PhoneCallLine = _interopRequireDefault(require("./iconTypes/16PhoneCallLine.js"));

var _PhoneCallLine2 = _interopRequireDefault(require("./iconTypes/24PhoneCallLine.js"));

var _PhotoFill = _interopRequireDefault(require("./iconTypes/16PhotoFill.js"));

var _PhotoFill2 = _interopRequireDefault(require("./iconTypes/24PhotoFill.js"));

var _PhotoLine = _interopRequireDefault(require("./iconTypes/16PhotoLine.js"));

var _PhotoLine2 = _interopRequireDefault(require("./iconTypes/24PhotoLine.js"));

var _PhotoUploadFill = _interopRequireDefault(require("./iconTypes/16PhotoUploadFill.js"));

var _PhotoUploadFill2 = _interopRequireDefault(require("./iconTypes/24PhotoUploadFill.js"));

var _PhotoUploadLine = _interopRequireDefault(require("./iconTypes/16PhotoUploadLine.js"));

var _PhotoUploadLine2 = _interopRequireDefault(require("./iconTypes/24PhotoUploadLine.js"));

var _PhotosFill = _interopRequireDefault(require("./iconTypes/16PhotosFill.js"));

var _PhotosFill2 = _interopRequireDefault(require("./iconTypes/24PhotosFill.js"));

var _PhotosLine = _interopRequireDefault(require("./iconTypes/16PhotosLine.js"));

var _PhotosLine2 = _interopRequireDefault(require("./iconTypes/24PhotosLine.js"));

var _PrintFill = _interopRequireDefault(require("./iconTypes/16PrintFill.js"));

var _PrintFill2 = _interopRequireDefault(require("./iconTypes/24PrintFill.js"));

var _PrintLine = _interopRequireDefault(require("./iconTypes/16PrintLine.js"));

var _PrintLine2 = _interopRequireDefault(require("./iconTypes/24PrintLine.js"));

var _ProhibitedFill = _interopRequireDefault(require("./iconTypes/16ProhibitedFill.js"));

var _ProhibitedFill2 = _interopRequireDefault(require("./iconTypes/24ProhibitedFill.js"));

var _ProhibitedLine = _interopRequireDefault(require("./iconTypes/16ProhibitedLine.js"));

var _ProhibitedLine2 = _interopRequireDefault(require("./iconTypes/24ProhibitedLine.js"));

var _PromoFill = _interopRequireDefault(require("./iconTypes/16PromoFill.js"));

var _PromoFill2 = _interopRequireDefault(require("./iconTypes/24PromoFill.js"));

var _PromoLine = _interopRequireDefault(require("./iconTypes/16PromoLine.js"));

var _PromoLine2 = _interopRequireDefault(require("./iconTypes/24PromoLine.js"));

var _RadioOffCircleLine = _interopRequireDefault(require("./iconTypes/16RadioOffCircleLine.js"));

var _RadioOffCircleLine2 = _interopRequireDefault(require("./iconTypes/24RadioOffCircleLine.js"));

var _RadioOnCircleFill = _interopRequireDefault(require("./iconTypes/16RadioOnCircleFill.js"));

var _RadioOnCircleFill2 = _interopRequireDefault(require("./iconTypes/24RadioOnCircleFill.js"));

var _ReceiptCancelOrderFill = _interopRequireDefault(require("./iconTypes/16ReceiptCancelOrderFill.js"));

var _ReceiptCancelOrderFill2 = _interopRequireDefault(require("./iconTypes/24ReceiptCancelOrderFill.js"));

var _ReceiptCancelOrderLine = _interopRequireDefault(require("./iconTypes/16ReceiptCancelOrderLine.js"));

var _ReceiptCancelOrderLine2 = _interopRequireDefault(require("./iconTypes/24ReceiptCancelOrderLine.js"));

var _ReceiptFill = _interopRequireDefault(require("./iconTypes/16ReceiptFill.js"));

var _ReceiptFill2 = _interopRequireDefault(require("./iconTypes/24ReceiptFill.js"));

var _ReceiptLine = _interopRequireDefault(require("./iconTypes/16ReceiptLine.js"));

var _ReceiptLine2 = _interopRequireDefault(require("./iconTypes/24ReceiptLine.js"));

var _RunTest = _interopRequireDefault(require("./iconTypes/16RunTest.js"));

var _RunTest2 = _interopRequireDefault(require("./iconTypes/24RunTest.js"));

var _Scan = _interopRequireDefault(require("./iconTypes/16Scan.js"));

var _Scan2 = _interopRequireDefault(require("./iconTypes/24Scan.js"));

var _Search = _interopRequireDefault(require("./iconTypes/16Search.js"));

var _Search2 = _interopRequireDefault(require("./iconTypes/24Search.js"));

var _Send = _interopRequireDefault(require("./iconTypes/16Send.js"));

var _Send2 = _interopRequireDefault(require("./iconTypes/24Send.js"));

var _SettingsFill = _interopRequireDefault(require("./iconTypes/16SettingsFill.js"));

var _SettingsFill2 = _interopRequireDefault(require("./iconTypes/24SettingsFill.js"));

var _SettingsLine = _interopRequireDefault(require("./iconTypes/16SettingsLine.js"));

var _SettingsLine2 = _interopRequireDefault(require("./iconTypes/24SettingsLine.js"));

var _ShareFill = _interopRequireDefault(require("./iconTypes/16ShareFill.js"));

var _ShareFill2 = _interopRequireDefault(require("./iconTypes/24ShareFill.js"));

var _ShareLine = _interopRequireDefault(require("./iconTypes/16ShareLine.js"));

var _ShareLine2 = _interopRequireDefault(require("./iconTypes/24ShareLine.js"));

var _SignalHigh = _interopRequireDefault(require("./iconTypes/16SignalHigh.js"));

var _SignalHigh2 = _interopRequireDefault(require("./iconTypes/24SignalHigh.js"));

var _SignalLow = _interopRequireDefault(require("./iconTypes/16SignalLow.js"));

var _SignalLow2 = _interopRequireDefault(require("./iconTypes/24SignalLow.js"));

var _SignalMedium = _interopRequireDefault(require("./iconTypes/16SignalMedium.js"));

var _SignalMedium2 = _interopRequireDefault(require("./iconTypes/24SignalMedium.js"));

var _StarFill = _interopRequireDefault(require("./iconTypes/16StarFill.js"));

var _StarFill2 = _interopRequireDefault(require("./iconTypes/24StarFill.js"));

var _StarHalf = _interopRequireDefault(require("./iconTypes/16StarHalf.js"));

var _StarHalf2 = _interopRequireDefault(require("./iconTypes/24StarHalf.js"));

var _StarLine = _interopRequireDefault(require("./iconTypes/16StarLine.js"));

var _StarLine2 = _interopRequireDefault(require("./iconTypes/24StarLine.js"));

var _Subtract = _interopRequireDefault(require("./iconTypes/16Subtract.js"));

var _Subtract2 = _interopRequireDefault(require("./iconTypes/24Subtract.js"));

var _SubtractCircleFill = _interopRequireDefault(require("./iconTypes/16SubtractCircleFill.js"));

var _SubtractCircleFill2 = _interopRequireDefault(require("./iconTypes/24SubtractCircleFill.js"));

var _SubtractCircleLine = _interopRequireDefault(require("./iconTypes/16SubtractCircleLine.js"));

var _SubtractCircleLine2 = _interopRequireDefault(require("./iconTypes/24SubtractCircleLine.js"));

var _SubtractSquareFill = _interopRequireDefault(require("./iconTypes/16SubtractSquareFill.js"));

var _SubtractSquareFill2 = _interopRequireDefault(require("./iconTypes/24SubtractSquareFill.js"));

var _SubtractSquareLine = _interopRequireDefault(require("./iconTypes/16SubtractSquareLine.js"));

var _SubtractSquareLine2 = _interopRequireDefault(require("./iconTypes/24SubtractSquareLine.js"));

var _Swap = _interopRequireDefault(require("./iconTypes/16Swap.js"));

var _Swap2 = _interopRequireDefault(require("./iconTypes/24Swap.js"));

var _SwapCircleFill = _interopRequireDefault(require("./iconTypes/16SwapCircleFill.js"));

var _SwapCircleLine = _interopRequireDefault(require("./iconTypes/16SwapCircleLine.js"));

var _SwapCircleLine2 = _interopRequireDefault(require("./iconTypes/24SwapCircleLine.js"));

var _SwapCirlceFill = _interopRequireDefault(require("./iconTypes/24SwapCirlceFill.js"));

var _ThumbsDownLine = _interopRequireDefault(require("./iconTypes/16ThumbsDownLine.js"));

var _ThumbsDownLine2 = _interopRequireDefault(require("./iconTypes/24ThumbsDownLine.js"));

var _ThumbsUpLine = _interopRequireDefault(require("./iconTypes/16ThumbsUpLine.js"));

var _ThumbsUpLine2 = _interopRequireDefault(require("./iconTypes/24ThumbsUpLine.js"));

var _TimeFill = _interopRequireDefault(require("./iconTypes/16TimeFill.js"));

var _TimeFill2 = _interopRequireDefault(require("./iconTypes/24TimeFill.js"));

var _TimeLine = _interopRequireDefault(require("./iconTypes/16TimeLine.js"));

var _TimeLine2 = _interopRequireDefault(require("./iconTypes/24TimeLine.js"));

var _ToteFill = _interopRequireDefault(require("./iconTypes/16ToteFill.js"));

var _ToteFill2 = _interopRequireDefault(require("./iconTypes/24ToteFill.js"));

var _ToteLine = _interopRequireDefault(require("./iconTypes/16ToteLine.js"));

var _ToteLine2 = _interopRequireDefault(require("./iconTypes/24ToteLine.js"));

var _TrashFill = _interopRequireDefault(require("./iconTypes/16TrashFill.js"));

var _TrashFill2 = _interopRequireDefault(require("./iconTypes/24TrashFill.js"));

var _TrashLine = _interopRequireDefault(require("./iconTypes/16TrashLine.js"));

var _TrashLine2 = _interopRequireDefault(require("./iconTypes/24TrashLine.js"));

var _UnlockedFill = _interopRequireDefault(require("./iconTypes/16UnlockedFill.js"));

var _UnlockedFill2 = _interopRequireDefault(require("./iconTypes/24UnlockedFill.js"));

var _UnlockedLine = _interopRequireDefault(require("./iconTypes/16UnlockedLine.js"));

var _UnlockedLine2 = _interopRequireDefault(require("./iconTypes/24UnlockedLine.js"));

var _UploadFill = _interopRequireDefault(require("./iconTypes/16UploadFill.js"));

var _UploadFill2 = _interopRequireDefault(require("./iconTypes/24UploadFill.js"));

var _UploadLine = _interopRequireDefault(require("./iconTypes/16UploadLine.js"));

var _UploadLine2 = _interopRequireDefault(require("./iconTypes/24UploadLine.js"));

var _VehicleBikeFill = _interopRequireDefault(require("./iconTypes/16VehicleBikeFill.js"));

var _VehicleBikeFill2 = _interopRequireDefault(require("./iconTypes/24VehicleBikeFill.js"));

var _VehicleBikeLine = _interopRequireDefault(require("./iconTypes/16VehicleBikeLine.js"));

var _VehicleBikeLine2 = _interopRequireDefault(require("./iconTypes/24VehicleBikeLine.js"));

var _VehicleCar = _interopRequireDefault(require("./iconTypes/16VehicleCar.js"));

var _VehicleCar2 = _interopRequireDefault(require("./iconTypes/24VehicleCar.js"));

var _VehicleEbikeFill = _interopRequireDefault(require("./iconTypes/16VehicleEbikeFill.js"));

var _VehicleEbikeFill2 = _interopRequireDefault(require("./iconTypes/24VehicleEbikeFill.js"));

var _VehicleEbikeLine = _interopRequireDefault(require("./iconTypes/16VehicleEbikeLine.js"));

var _VehicleEbikeLine2 = _interopRequireDefault(require("./iconTypes/24VehicleEbikeLine.js"));

var _VehicleMotorcycleFill = _interopRequireDefault(require("./iconTypes/16VehicleMotorcycleFill.js"));

var _VehicleMotorcycleFill2 = _interopRequireDefault(require("./iconTypes/24VehicleMotorcycleFill.js"));

var _VehicleMotorcycleLine = _interopRequireDefault(require("./iconTypes/16VehicleMotorcycleLine.js"));

var _VehicleMotorcycleLine2 = _interopRequireDefault(require("./iconTypes/24VehicleMotorcycleLine.js"));

var _VehicleScooterFill = _interopRequireDefault(require("./iconTypes/16VehicleScooterFill.js"));

var _VehicleScooterFill2 = _interopRequireDefault(require("./iconTypes/24VehicleScooterFill.js"));

var _VehicleScooterLine = _interopRequireDefault(require("./iconTypes/16VehicleScooterLine.js"));

var _VehicleScooterLine2 = _interopRequireDefault(require("./iconTypes/24VehicleScooterLine.js"));

var _VehicleWalk = _interopRequireDefault(require("./iconTypes/16VehicleWalk.js"));

var _VehicleWalk2 = _interopRequireDefault(require("./iconTypes/24VehicleWalk.js"));

var _ViewCollapse = _interopRequireDefault(require("./iconTypes/16ViewCollapse.js"));

var _ViewCollapse2 = _interopRequireDefault(require("./iconTypes/24ViewCollapse.js"));

var _ViewExpand = _interopRequireDefault(require("./iconTypes/16ViewExpand.js"));

var _ViewExpand2 = _interopRequireDefault(require("./iconTypes/24ViewExpand.js"));

var _WarningCircleFill = _interopRequireDefault(require("./iconTypes/16WarningCircleFill.js"));

var _WarningCircleFill2 = _interopRequireDefault(require("./iconTypes/24WarningCircleFill.js"));

var _WarningCircleLine = _interopRequireDefault(require("./iconTypes/16WarningCircleLine.js"));

var _WarningCircleLine2 = _interopRequireDefault(require("./iconTypes/24WarningCircleLine.js"));

var _WarningTriangleFill = _interopRequireDefault(require("./iconTypes/16WarningTriangleFill.js"));

var _WarningTriangleFill2 = _interopRequireDefault(require("./iconTypes/24WarningTriangleFill.js"));

var _WarningTriangleLine = _interopRequireDefault(require("./iconTypes/16WarningTriangleLine.js"));

var _WarningTriangleLine2 = _interopRequireDefault(require("./iconTypes/24WarningTriangleLine.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// THIS IS A GENERATED FILE, DO NOT EDIT MANUALLY

/* eslint-disable sort-imports */
var _default = {
  Add: {
    16: _Add.default,
    24: _Add2.default
  },
  AddCircleFill: {
    16: _AddCircleFill.default,
    24: _AddCircleFill2.default
  },
  AddCircleLine: {
    16: _AddCircleLine.default,
    24: _AddCircleLine2.default
  },
  AddSquareFill: {
    16: _AddSquareFill.default,
    24: _AddSquareFill2.default
  },
  AddSquareLine: {
    16: _AddSquareLine.default,
    24: _AddSquareLine2.default
  },
  AlcoholLine: {
    24: _AlcoholLine.default
  },
  ArrowDown: {
    16: _ArrowDown.default,
    24: _ArrowDown2.default
  },
  ArrowDownLeft: {
    16: _ArrowDownLeft.default,
    24: _ArrowDownLeft2.default
  },
  ArrowDownRight: {
    16: _ArrowDownRight.default,
    24: _ArrowDownRight2.default
  },
  ArrowLeft: {
    16: _ArrowLeft.default,
    24: _ArrowLeft2.default
  },
  ArrowRight: {
    16: _ArrowRight.default,
    24: _ArrowRight2.default
  },
  ArrowUp: {
    16: _ArrowUp.default,
    24: _ArrowUp2.default
  },
  ArrowUpLeft: {
    16: _ArrowUpLeft.default,
    24: _ArrowUpLeft2.default
  },
  ArrowUpRight: {
    16: _ArrowUpRight.default,
    24: _ArrowUpRight2.default
  },
  BlobAlmondblob: {
    16: _BlobAlmondblob.default,
    24: _BlobAlmondblob2.default
  },
  BlobAvoblob: {
    16: _BlobAvoblob.default,
    24: _BlobAvoblob2.default
  },
  BlobMusselblob: {
    16: _BlobMusselblob.default,
    24: _BlobMusselblob2.default
  },
  BlobPearblob: {
    16: _BlobPearblob.default,
    24: _BlobPearblob2.default
  },
  BlobRibsblob: {
    16: _BlobRibsblob.default,
    24: _BlobRibsblob2.default
  },
  BlobSteakblob: {
    16: _BlobSteakblob.default,
    24: _BlobSteakblob2.default
  },
  BoltFill: {
    16: _BoltFill.default,
    24: _BoltFill2.default
  },
  BoltLine: {
    16: _BoltLine.default,
    24: _BoltLine2.default
  },
  BrowseFill: {
    16: _BrowseFill.default,
    24: _BrowseFill2.default
  },
  BrowseLine: {
    16: _BrowseLine.default,
    24: _BrowseLine2.default
  },
  CalendarAddFill: {
    16: _CalendarAddFill.default,
    24: _CalendarAddFill2.default
  },
  CalendarAddLine: {
    16: _CalendarAddLine.default,
    24: _CalendarAddLine2.default
  },
  CalendarCancelFill: {
    16: _CalendarCancelFill.default,
    24: _CalendarCancelFill2.default
  },
  CalendarCancelLine: {
    16: _CalendarCancelLine.default,
    24: _CalendarCancelLine2.default
  },
  CalendarCheckFill: {
    16: _CalendarCheckFill.default,
    24: _CalendarCheckFill2.default
  },
  CalendarCheckLine: {
    16: _CalendarCheckLine.default,
    24: _CalendarCheckLine2.default
  },
  CalendarFill: {
    16: _CalendarFill.default,
    24: _CalendarFill2.default
  },
  CalendarLine: {
    16: _CalendarLine.default,
    24: _CalendarLine2.default
  },
  CallCustomer: {
    24: _CallCustomer.default
  },
  CallDasher: {
    24: _CallDasher.default
  },
  CallMerchant: {
    24: _CallMerchant.default
  },
  CallOffice: {
    24: _CallOffice.default
  },
  CameraFill: {
    16: _CameraFill.default,
    24: _CameraFill2.default
  },
  CameraLine: {
    16: _CameraLine.default,
    24: _CameraLine2.default
  },
  CardFill: {
    16: _CardFill.default,
    24: _CardFill2.default
  },
  CardLine: {
    16: _CardLine.default,
    24: _CardLine2.default
  },
  CartFill: {
    16: _CartFill.default,
    24: _CartFill2.default
  },
  CartLine: {
    16: _CartLine.default,
    24: _CartLine2.default
  },
  Challenge: {
    16: _Challenge.default,
    24: _Challenge2.default
  },
  ChatConversation: {
    24: _ChatConversation.default
  },
  ChatCustomer: {
    24: _ChatCustomer.default
  },
  ChatDasher: {
    24: _ChatDasher.default
  },
  ChatDefaultFill: {
    16: _ChatDefaultFill.default,
    24: _ChatDefaultFill2.default
  },
  ChatDefaultLine: {
    16: _ChatDefaultLine.default,
    24: _ChatDefaultLine2.default
  },
  ChatMerchant: {
    24: _ChatMerchant.default
  },
  ChatOffice: {
    24: _ChatOffice.default
  },
  Check: {
    16: _Check.default,
    24: _Check2.default
  },
  CheckCircleFill: {
    16: _CheckCircleFill.default,
    24: _CheckCircleFill2.default
  },
  CheckCircleLine: {
    16: _CheckCircleLine.default,
    24: _CheckCircleLine2.default
  },
  CheckSquareFill: {
    16: _CheckSquareFill.default,
    24: _CheckSquareFill2.default
  },
  CheckSquareLine: {
    16: _CheckSquareLine.default,
    24: _CheckSquareLine2.default
  },
  CheckSquareOffLine: {
    16: _CheckSquareOffLine.default,
    24: _CheckSquareOffLine2.default
  },
  ChevronDown: {
    16: _ChevronDown.default,
    24: _ChevronDown2.default
  },
  ChevronLeft: {
    16: _ChevronLeft.default,
    24: _ChevronLeft2.default
  },
  ChevronRight: {
    16: _ChevronRight.default,
    24: _ChevronRight2.default
  },
  ChevronUp: {
    16: _ChevronUp.default,
    24: _ChevronUp2.default
  },
  Close: {
    16: _Close.default,
    24: _Close2.default
  },
  CloseCircleFill: {
    16: _CloseCircleFill.default,
    24: _CloseCircleFill2.default
  },
  CloseCircleLine: {
    16: _CloseCircleLine.default,
    24: _CloseCircleLine2.default
  },
  CloseSquareFill: {
    16: _CloseSquareFill.default,
    24: _CloseSquareFill2.default
  },
  CloseSquareLine: {
    16: _CloseSquareLine.default,
    24: _CloseSquareLine2.default
  },
  CopyFill: {
    16: _CopyFill.default,
    24: _CopyFill2.default
  },
  CopyLine: {
    16: _CopyLine.default,
    24: _CopyLine2.default
  },
  DashboardFill: {
    16: _DashboardFill.default,
    24: _DashboardFill2.default
  },
  DashboardLine: {
    16: _DashboardLine.default,
    24: _DashboardLine2.default
  },
  DealsFill: {
    16: _DealsFill.default,
    24: _DealsFill2.default
  },
  DealsLine: {
    16: _DealsLine.default,
    24: _DealsLine2.default
  },
  DevicePhone: {
    16: _DevicePhone.default,
    24: _DevicePhone2.default
  },
  DevicePosFill: {
    16: _DevicePosFill.default,
    24: _DevicePosFill2.default
  },
  DevicePosLine: {
    16: _DevicePosLine.default,
    24: _DevicePosLine2.default
  },
  DeviceTablet: {
    16: _DeviceTablet.default,
    24: _DeviceTablet2.default
  },
  DirectionsFill: {
    16: _DirectionsFill.default,
    24: _DirectionsFill2.default
  },
  DirectionsLine: {
    16: _DirectionsLine.default,
    24: _DirectionsLine2.default
  },
  DownloadFill: {
    16: _DownloadFill.default
  },
  DownloadLine: {
    24: _DownloadLine.default
  },
  EditFill: {
    16: _EditFill.default,
    24: _EditFill2.default
  },
  EditLine: {
    16: _EditLine.default,
    24: _EditLine2.default
  },
  EmailFill: {
    16: _EmailFill.default,
    24: _EmailFill2.default
  },
  EmailLine: {
    16: _EmailLine.default,
    24: _EmailLine2.default
  },
  EyeHiddenFill: {
    16: _EyeHiddenFill.default,
    24: _EyeHiddenFill2.default
  },
  EyeHiddenLine: {
    16: _EyeHiddenLine.default,
    24: _EyeHiddenLine2.default
  },
  EyeVisibleFill: {
    16: _EyeVisibleFill.default,
    24: _EyeVisibleFill2.default
  },
  EyeVisibleLine: {
    16: _EyeVisibleLine.default,
    24: _EyeVisibleLine2.default
  },
  FavoriteFill: {
    16: _FavoriteFill.default,
    24: _FavoriteFill2.default
  },
  FavoriteLine: {
    16: _FavoriteLine.default,
    24: _FavoriteLine2.default
  },
  FaxFill: {
    16: _FaxFill.default,
    24: _FaxFill2.default
  },
  FaxLine: {
    16: _FaxLine.default,
    24: _FaxLine2.default
  },
  FilterFill: {
    16: _FilterFill.default,
    24: _FilterFill2.default
  },
  FilterLine: {
    16: _FilterLine.default,
    24: _FilterLine2.default
  },
  FoodLine: {
    16: _FoodLine.default,
    24: _FoodLine2.default
  },
  FunnelLine: {
    16: _FunnelLine.default,
    24: _FunnelLine2.default
  },
  GlobeFill: {
    16: _GlobeFill.default,
    24: _GlobeFill2.default
  },
  GlobeLine: {
    16: _GlobeLine.default,
    24: _GlobeLine2.default
  },
  HalfFill: {
    16: _HalfFill.default,
    24: _HalfFill2.default
  },
  HalfLine: {
    16: _HalfLine.default,
    24: _HalfLine2.default
  },
  HelpCircleFill: {
    16: _HelpCircleFill.default,
    24: _HelpCircleFill2.default
  },
  HelpCircleLine: {
    16: _HelpCircleLine.default,
    24: _HelpCircleLine2.default
  },
  HelpLifesaver: {
    16: _HelpLifesaver.default,
    24: _HelpLifesaver2.default
  },
  HomeFill: {
    16: _HomeFill.default,
    24: _HomeFill2.default
  },
  HomeLine: {
    16: _HomeLine.default,
    24: _HomeLine2.default
  },
  InfoCircleFill: {
    16: _InfoCircleFill.default,
    24: _InfoCircleFill2.default
  },
  InfoCircleLine: {
    16: _InfoCircleLine.default,
    24: _InfoCircleLine2.default
  },
  List: {
    16: _List.default,
    24: _List2.default
  },
  LocationGpsFill: {
    16: _LocationGpsFill.default,
    24: _LocationGpsFill2.default
  },
  LocationGpsLine: {
    16: _LocationGpsLine.default,
    24: _LocationGpsLine2.default
  },
  LocationPinDisabledFill: {
    16: _LocationPinDisabledFill.default,
    24: _LocationPinDisabledFill2.default
  },
  LocationPinDisabledLine: {
    16: _LocationPinDisabledLine.default,
    24: _LocationPinDisabledLine2.default
  },
  LocationPinEnabledFill: {
    16: _LocationPinEnabledFill.default,
    24: _LocationPinEnabledFill2.default
  },
  LocationPinEnabledLine: {
    16: _LocationPinEnabledLine.default,
    24: _LocationPinEnabledLine2.default
  },
  LocationPointerFill: {
    16: _LocationPointerFill.default,
    24: _LocationPointerFill2.default
  },
  LocationPointerLine: {
    16: _LocationPointerLine.default,
    24: _LocationPointerLine2.default
  },
  LockedFill: {
    16: _LockedFill.default,
    24: _LockedFill2.default
  },
  LockedLine: {
    16: _LockedLine.default,
    24: _LockedLine2.default
  },
  LogoAndroid: {
    16: _LogoAndroid.default,
    24: _LogoAndroid2.default
  },
  LogoApple: {
    16: _LogoApple.default,
    24: _LogoApple2.default
  },
  LogoDashpass: {
    16: _LogoDashpass.default,
    24: _LogoDashpass2.default
  },
  LogoDashpassMonocolor: {
    16: _LogoDashpassMonocolor.default,
    24: _LogoDashpassMonocolor2.default
  },
  LogoDoordash: {
    16: _LogoDoordash.default,
    24: _LogoDoordash2.default
  },
  LogoFacebook: {
    16: _LogoFacebook.default,
    24: _LogoFacebook2.default
  },
  LogoGlassdoor: {
    16: _LogoGlassdoor.default,
    24: _LogoGlassdoor2.default
  },
  LogoGoogle: {
    16: _LogoGoogle.default,
    24: _LogoGoogle2.default
  },
  LogoInstagram: {
    16: _LogoInstagram.default,
    24: _LogoInstagram2.default
  },
  LogoLinkedin: {
    16: _LogoLinkedin.default,
    24: _LogoLinkedin2.default
  },
  LogoMedium: {
    16: _LogoMedium.default,
    24: _LogoMedium2.default
  },
  LogoTwitter: {
    16: _LogoTwitter.default,
    24: _LogoTwitter2.default
  },
  LogoutFill: {
    16: _LogoutFill.default
  },
  LogoutLine: {
    24: _LogoutLine.default
  },
  MapFill: {
    16: _MapFill.default,
    24: _MapFill2.default
  },
  MapLine: {
    16: _MapLine.default,
    24: _MapLine2.default
  },
  Menu: {
    16: _Menu.default,
    24: _Menu2.default
  },
  MenuEditFill: {
    16: _MenuEditFill.default,
    24: _MenuEditFill2.default
  },
  MenuEditLine: {
    16: _MenuEditLine.default,
    24: _MenuEditLine2.default
  },
  MenuShare: {
    16: _MenuShare.default,
    24: _MenuShare2.default
  },
  MerchantFill: {
    16: _MerchantFill.default,
    24: _MerchantFill2.default
  },
  MerchantLine: {
    16: _MerchantLine.default,
    24: _MerchantLine2.default
  },
  MoneyBank: {
    16: _MoneyBank.default,
    24: _MoneyBank2.default
  },
  MoneyCircleFill: {
    16: _MoneyCircleFill.default,
    24: _MoneyCircleFill2.default
  },
  MoneyCircleLine: {
    16: _MoneyCircleLine.default,
    24: _MoneyCircleLine2.default
  },
  MoneyDefault: {
    16: _MoneyDefault.default,
    24: _MoneyDefault2.default
  },
  MoreHorizontal: {
    16: _MoreHorizontal.default,
    24: _MoreHorizontal2.default
  },
  MoreVertical: {
    24: _MoreVertical.default
  },
  NotifyFill: {
    16: _NotifyFill.default,
    24: _NotifyFill2.default
  },
  NotifyLine: {
    16: _NotifyLine.default,
    24: _NotifyLine2.default
  },
  Office: {
    16: _Office.default,
    24: _Office2.default
  },
  OrderBagFill: {
    16: _OrderBagFill.default,
    24: _OrderBagFill2.default
  },
  OrderBagLine: {
    16: _OrderBagLine.default,
    24: _OrderBagLine2.default
  },
  OrderHotbagFill: {
    16: _OrderHotbagFill.default,
    24: _OrderHotbagFill2.default
  },
  OrderHotbagLine: {
    16: _OrderHotbagLine.default,
    24: _OrderHotbagLine2.default
  },
  OrderLargeFill: {
    16: _OrderLargeFill.default,
    24: _OrderLargeFill2.default
  },
  OrderLargeLine: {
    16: _OrderLargeLine.default,
    24: _OrderLargeLine2.default
  },
  OrderMediumFill: {
    16: _OrderMediumFill.default,
    24: _OrderMediumFill2.default
  },
  OrderMediumLine: {
    16: _OrderMediumLine.default,
    24: _OrderMediumLine2.default
  },
  OrderProtocol: {
    16: _OrderProtocol.default,
    24: _OrderProtocol2.default
  },
  OrderSmallFill: {
    16: _OrderSmallFill.default,
    24: _OrderSmallFill2.default
  },
  OrderSmallLine: {
    16: _OrderSmallLine.default,
    24: _OrderSmallLine2.default
  },
  PeopleAddFill: {
    16: _PeopleAddFill.default,
    24: _PeopleAddFill2.default
  },
  PeopleAddLine: {
    16: _PeopleAddLine.default,
    24: _PeopleAddLine2.default
  },
  PeopleGroupFill: {
    16: _PeopleGroupFill.default,
    24: _PeopleGroupFill2.default
  },
  PeopleGroupLine: {
    16: _PeopleGroupLine.default,
    24: _PeopleGroupLine2.default
  },
  PersonProfileFill: {
    16: _PersonProfileFill.default,
    24: _PersonProfileFill2.default
  },
  PersonProfileLine: {
    16: _PersonProfileLine.default,
    24: _PersonProfileLine2.default
  },
  PersonUserFill: {
    16: _PersonUserFill.default,
    24: _PersonUserFill2.default
  },
  PersonUserLine: {
    16: _PersonUserLine.default,
    24: _PersonUserLine2.default
  },
  PhoneCallFill: {
    16: _PhoneCallFill.default,
    24: _PhoneCallFill2.default
  },
  PhoneCallLine: {
    16: _PhoneCallLine.default,
    24: _PhoneCallLine2.default
  },
  PhotoFill: {
    16: _PhotoFill.default,
    24: _PhotoFill2.default
  },
  PhotoLine: {
    16: _PhotoLine.default,
    24: _PhotoLine2.default
  },
  PhotoUploadFill: {
    16: _PhotoUploadFill.default,
    24: _PhotoUploadFill2.default
  },
  PhotoUploadLine: {
    16: _PhotoUploadLine.default,
    24: _PhotoUploadLine2.default
  },
  PhotosFill: {
    16: _PhotosFill.default,
    24: _PhotosFill2.default
  },
  PhotosLine: {
    16: _PhotosLine.default,
    24: _PhotosLine2.default
  },
  PrintFill: {
    16: _PrintFill.default,
    24: _PrintFill2.default
  },
  PrintLine: {
    16: _PrintLine.default,
    24: _PrintLine2.default
  },
  ProhibitedFill: {
    16: _ProhibitedFill.default,
    24: _ProhibitedFill2.default
  },
  ProhibitedLine: {
    16: _ProhibitedLine.default,
    24: _ProhibitedLine2.default
  },
  PromoFill: {
    16: _PromoFill.default,
    24: _PromoFill2.default
  },
  PromoLine: {
    16: _PromoLine.default,
    24: _PromoLine2.default
  },
  RadioOffCircleLine: {
    16: _RadioOffCircleLine.default,
    24: _RadioOffCircleLine2.default
  },
  RadioOnCircleFill: {
    16: _RadioOnCircleFill.default,
    24: _RadioOnCircleFill2.default
  },
  ReceiptCancelOrderFill: {
    16: _ReceiptCancelOrderFill.default,
    24: _ReceiptCancelOrderFill2.default
  },
  ReceiptCancelOrderLine: {
    16: _ReceiptCancelOrderLine.default,
    24: _ReceiptCancelOrderLine2.default
  },
  ReceiptFill: {
    16: _ReceiptFill.default,
    24: _ReceiptFill2.default
  },
  ReceiptLine: {
    16: _ReceiptLine.default,
    24: _ReceiptLine2.default
  },
  RunTest: {
    16: _RunTest.default,
    24: _RunTest2.default
  },
  Scan: {
    16: _Scan.default,
    24: _Scan2.default
  },
  Search: {
    16: _Search.default,
    24: _Search2.default
  },
  Send: {
    16: _Send.default,
    24: _Send2.default
  },
  SettingsFill: {
    16: _SettingsFill.default,
    24: _SettingsFill2.default
  },
  SettingsLine: {
    16: _SettingsLine.default,
    24: _SettingsLine2.default
  },
  ShareFill: {
    16: _ShareFill.default,
    24: _ShareFill2.default
  },
  ShareLine: {
    16: _ShareLine.default,
    24: _ShareLine2.default
  },
  SignalHigh: {
    16: _SignalHigh.default,
    24: _SignalHigh2.default
  },
  SignalLow: {
    16: _SignalLow.default,
    24: _SignalLow2.default
  },
  SignalMedium: {
    16: _SignalMedium.default,
    24: _SignalMedium2.default
  },
  StarFill: {
    16: _StarFill.default,
    24: _StarFill2.default
  },
  StarHalf: {
    16: _StarHalf.default,
    24: _StarHalf2.default
  },
  StarLine: {
    16: _StarLine.default,
    24: _StarLine2.default
  },
  Subtract: {
    16: _Subtract.default,
    24: _Subtract2.default
  },
  SubtractCircleFill: {
    16: _SubtractCircleFill.default,
    24: _SubtractCircleFill2.default
  },
  SubtractCircleLine: {
    16: _SubtractCircleLine.default,
    24: _SubtractCircleLine2.default
  },
  SubtractSquareFill: {
    16: _SubtractSquareFill.default,
    24: _SubtractSquareFill2.default
  },
  SubtractSquareLine: {
    16: _SubtractSquareLine.default,
    24: _SubtractSquareLine2.default
  },
  Swap: {
    16: _Swap.default,
    24: _Swap2.default
  },
  SwapCircleFill: {
    16: _SwapCircleFill.default
  },
  SwapCircleLine: {
    16: _SwapCircleLine.default,
    24: _SwapCircleLine2.default
  },
  SwapCirlceFill: {
    24: _SwapCirlceFill.default
  },
  ThumbsDownLine: {
    16: _ThumbsDownLine.default,
    24: _ThumbsDownLine2.default
  },
  ThumbsUpLine: {
    16: _ThumbsUpLine.default,
    24: _ThumbsUpLine2.default
  },
  TimeFill: {
    16: _TimeFill.default,
    24: _TimeFill2.default
  },
  TimeLine: {
    16: _TimeLine.default,
    24: _TimeLine2.default
  },
  ToteFill: {
    16: _ToteFill.default,
    24: _ToteFill2.default
  },
  ToteLine: {
    16: _ToteLine.default,
    24: _ToteLine2.default
  },
  TrashFill: {
    16: _TrashFill.default,
    24: _TrashFill2.default
  },
  TrashLine: {
    16: _TrashLine.default,
    24: _TrashLine2.default
  },
  UnlockedFill: {
    16: _UnlockedFill.default,
    24: _UnlockedFill2.default
  },
  UnlockedLine: {
    16: _UnlockedLine.default,
    24: _UnlockedLine2.default
  },
  UploadFill: {
    16: _UploadFill.default,
    24: _UploadFill2.default
  },
  UploadLine: {
    16: _UploadLine.default,
    24: _UploadLine2.default
  },
  VehicleBikeFill: {
    16: _VehicleBikeFill.default,
    24: _VehicleBikeFill2.default
  },
  VehicleBikeLine: {
    16: _VehicleBikeLine.default,
    24: _VehicleBikeLine2.default
  },
  VehicleCar: {
    16: _VehicleCar.default,
    24: _VehicleCar2.default
  },
  VehicleEbikeFill: {
    16: _VehicleEbikeFill.default,
    24: _VehicleEbikeFill2.default
  },
  VehicleEbikeLine: {
    16: _VehicleEbikeLine.default,
    24: _VehicleEbikeLine2.default
  },
  VehicleMotorcycleFill: {
    16: _VehicleMotorcycleFill.default,
    24: _VehicleMotorcycleFill2.default
  },
  VehicleMotorcycleLine: {
    16: _VehicleMotorcycleLine.default,
    24: _VehicleMotorcycleLine2.default
  },
  VehicleScooterFill: {
    16: _VehicleScooterFill.default,
    24: _VehicleScooterFill2.default
  },
  VehicleScooterLine: {
    16: _VehicleScooterLine.default,
    24: _VehicleScooterLine2.default
  },
  VehicleWalk: {
    16: _VehicleWalk.default,
    24: _VehicleWalk2.default
  },
  ViewCollapse: {
    16: _ViewCollapse.default,
    24: _ViewCollapse2.default
  },
  ViewExpand: {
    16: _ViewExpand.default,
    24: _ViewExpand2.default
  },
  WarningCircleFill: {
    16: _WarningCircleFill.default,
    24: _WarningCircleFill2.default
  },
  WarningCircleLine: {
    16: _WarningCircleLine.default,
    24: _WarningCircleLine2.default
  },
  WarningTriangleFill: {
    16: _WarningTriangleFill.default,
    24: _WarningTriangleFill2.default
  },
  WarningTriangleLine: {
    16: _WarningTriangleLine.default,
    24: _WarningTriangleLine2.default
  }
};
exports.default = _default;